import script from "./MenuView.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuView.vue?vue&type=script&setup=true&lang=js"

import "./MenuView.vue?vue&type=style&index=0&id=08508087&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08508087"]])

export default __exports__